<mat-card class="card">
    <mat-card-header [ngClass]="title ? 'justify-content-center' + ' ' + headerClass : headerClass">
      <div class="header-left">
        <ng-content select="[toggle]"></ng-content>
      </div>
      <div *ngIf="title" class="header-center ps-2 ps-md-0">
        <mat-card-title *ngIf="title">{{title}}</mat-card-title>
      </div>
      <div class="header-right">
        <ng-content select="[header]"></ng-content>
      </div>

    </mat-card-header>
    <mat-card-content>
      <ng-content select="[body]"></ng-content>
    </mat-card-content>
</mat-card>